const MIDDLE_DOT = '\u00B7'

type LeadInquirySubtitleProps = {
  consumerName: string
  clientType: string
}

const LeadInquirySubtitle = ({ consumerName, clientType }: LeadInquirySubtitleProps) => {
  const subtitle = [consumerName, clientType].filter(Boolean).join(` ${MIDDLE_DOT} `)

  if (!subtitle) {
    return null
  }

  return <p className="text-[13px] leading-[18px] text-muted">{subtitle}</p>
}

export default LeadInquirySubtitle
